module.exports = __webpack_public_path__ + "static/media/pin.f696a775.svg";